/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Dietician_BodyInputs */

const en_for_whom_dietician_body = /** @type {(inputs: For_Whom_Dietician_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A meal plan for your goal, and calories counted from a photo of your plate instead of a scale.`)
};

const pl_for_whom_dietician_body = /** @type {(inputs: For_Whom_Dietician_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jadłospis pod Twój cel, a kalorie liczysz zdjęciem talerza zamiast wagą.`)
};

/**
* | output |
* | --- |
* | "A meal plan for your goal, and calories counted from a photo of your plate instead of a scale." |
*
* @param {For_Whom_Dietician_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_dietician_body = /** @type {((inputs?: For_Whom_Dietician_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Dietician_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_dietician_body(inputs)
	return en_for_whom_dietician_body(inputs)
});